import { z } from 'zod';

export const companyEmploymentTypesSchema = z.object({
  offersFreelanceWork: z.boolean(),
  offersTempWork: z.boolean(),
  offersEmployeeWork: z.boolean(),
});

export type GetCompanyEmploymentTypes = z.infer<typeof companyEmploymentTypesSchema>;

export const companySchema = z.object({
  id: z.string(),
  name: z.string(),
  branchOfficesCount: z.number(),
  offersFreelanceWork: z.boolean(),
  offersTempWork: z.boolean(),
  offersEmployeeWork: z.boolean(),
});

export const companiesSchema = z.array(companySchema);

export type Companies = z.infer<typeof companiesSchema>;
